import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-4 mb-3">
          <span className="text-xs font-semibold tracking-[0.15em] text-foreground-500 font-label uppercase">Curated Categories</span>
          <div className="h-px flex-1 bg-foreground-200/40"></div>
        </div>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-12">
          Browse by Category
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {categories.slice(0, 3).map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
                idx === 0
                  ? 'bg-foreground-900 p-8 min-h-[280px] flex flex-col justify-between'
                  : idx === 1
                  ? 'bg-background-50 p-8 min-h-[280px] flex flex-col justify-between'
                  : 'bg-accent-100/60 p-8 min-h-[280px] flex flex-col justify-between'
              }`}
            >
              {idx === 0 && (
                <>
                  <div className="w-14 h-14 rounded-2xl bg-foreground-700 flex items-center justify-center mb-auto">
                    <span className="text-background-50 text-2xl font-heading font-bold">{cat.name.charAt(0)}</span>
                  </div>
                  <div>
                    <h3 className="text-background-50 text-2xl font-heading font-semibold mb-2">{cat.name}</h3>
                    <p className="text-foreground-300 text-sm">{cat.description}</p>
                  </div>
                </>
              )}
              {idx === 1 && (
                <>
                  <div className="absolute inset-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20vintage%20washed%20indigo%20denim%20jacket%20draped%20over%20textured%20concrete%20surface%20with%20copper%20tone%20accessories%20scattered%20naturally%20industrial%20chic%20editorial%20style%20with%20cool%20blue%20grey%20palette%20and%20soft%20morning%20light%20streaming%20from%20above&width=800&height=600&seq=cat-denim-july2026&orientation=landscape"
                      alt={cat.name}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-foreground-950/30"></div>
                  </div>
                  <div className="relative z-10 mb-auto">
                    <span className="inline-block px-3 py-1 bg-background-50/20 backdrop-blur-sm text-background-50 text-xs rounded-full font-label">
                      <i className="ri-flashlight-line mr-1 w-4 h-4 flex items-center justify-center"></i> Streetwear
                    </span>
                  </div>
                  <div className="relative z-10">
                    <h3 className="text-background-50 text-2xl font-heading font-semibold">{cat.name}</h3>
                  </div>
                </>
              )}
              {idx === 2 && (
                <>
                  <div className="mb-auto">
                    <h3 className="text-foreground-950 text-2xl font-heading font-semibold mb-2">{cat.name}</h3>
                    <p className="text-foreground-600 text-sm">{cat.description}</p>
                  </div>
                  <div className="mt-4 rounded-xl overflow-hidden h-32">
                    <img
                      src="https://readdy.ai/api/search-image?query=Carefully%20composed%20arrangement%20of%20woven%20straw%20hat%20leather%20bound%20journal%20and%20tortoiseshell%20sunglasses%20on%20sun%20bleached%20driftwood%20surface%20mediterranean%20summer%20aesthetic%20with%20warm%20golden%20hour%20light%20and%20soft%20ocean%20horizon%20blurred%20in%20background&width=800&height=400&seq=cat-mediterranean-july2026&orientation=landscape"
                      alt={cat.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </>
              )}
            </a>
          ))}
        </div>

        <div className="flex flex-wrap gap-2.5">
          {categories.slice(3).map((cat, idx) => {
            const pillStyles = [
              'bg-foreground-900 text-background-50 hover:bg-foreground-800',
              'bg-background-50 text-foreground-950 border border-foreground-200 hover:bg-background-100',
              'bg-primary-100 text-primary-800 hover:bg-primary-200',
              'bg-background-50 text-foreground-950 border border-foreground-200 hover:bg-background-100',
              'bg-accent-100 text-accent-800 hover:bg-accent-200',
              'bg-background-50 text-foreground-950 border border-foreground-200 hover:bg-background-100',
              'bg-secondary-100 text-secondary-800 hover:bg-secondary-200',
              'bg-background-50 text-foreground-950 border border-foreground-200 hover:bg-background-100',
              'bg-foreground-900 text-background-50 hover:bg-foreground-800',
              'bg-accent-100 text-accent-800 hover:bg-accent-200',
              'bg-background-50 text-foreground-950 border border-foreground-200 hover:bg-background-100',
            ];
            const style = pillStyles[idx % pillStyles.length];

            return (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${style}`}
              >
                {cat.name}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}